module.exports = "<div class=form-group> <div type=text style=min-height:250px data-bind=\"quill: _body\"></div> </div>";